import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class GooglePlacesService {

  private autocompleteService!: google.maps.places.AutocompleteService;
  private loadingPromise!: Promise<void>;
  private initialized = false;

  constructor() { }

  private loadGoogleMaps(): Promise<void> {
    if (this.loadingPromise) {
      return this.loadingPromise;
    }

    this.loadingPromise = new Promise((resolve, reject) => {

      if ((window as any).google && (window as any).google.maps) {
        this.initService();
        resolve();
        return;
      }

      const script = document.createElement('script');
      script.src = `https://maps.googleapis.com/maps/api/js?key=${environment.googlePalcesApiKey}&libraries=places`;
      script.async = true;
      script.defer = true;

      script.onload = () => {
        this.initService();
        resolve();
      };

      script.onerror = () => reject('Failed to load Google Maps');

      document.body.appendChild(script);
    });

    return this.loadingPromise;
  }

  private initService() {
    if (!this.initialized) {
      this.autocompleteService = new google.maps.places.AutocompleteService();
      this.initialized = true;
    }
  }

  async getPlacePredictions(input: string, types: string[] = [], componentRestrictions: any): Promise<google.maps.places.AutocompletePrediction[]> {

    await this.loadGoogleMaps();

    return new Promise((resolve, reject) => {
      const request: google.maps.places.AutocompletionRequest = {
        input,
        types,
        componentRestrictions
      };

      this.autocompleteService.getPlacePredictions(request, (predictions, status) => {
        if (status === google.maps.places.PlacesServiceStatus.OK) {
          resolve(predictions || []);
        } else {
          reject(`Error fetching predictions: ${status}`);
        }
      });
    });
  }
}
